import React, { useState, useEffect} from "react";
import { ErrorTost, SuccessTost } from "../../utils/ToastHelper";
import { Apirequests } from "../../utils/ApiRequests";
import BtnSpinner from "../../components/BtnSpinner";

const EditUser = ({ close, setRefresh, user }) => {

    // console.log(user,'user')

    const token = localStorage.getItem("token");

    const [formData, setFormData] = useState({
        name: "",
        phone: "",
        email: "",
        password: "",
        confirmPassword: "",
        user_type:"",
    });
    const [loading, setLoading] = useState(false);

    // Fetch user data for editing
    useEffect(() => {
        if (user) {
            setFormData({
                name: user?.name,
                email: user?.email,
                phone: user?.phone,
                user_type: user?.user_type
            })
        }
    }, [user]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const { name, email, phone,password,confirmPassword,user_type } = formData;


        if(password !== confirmPassword){
            return ErrorTost("Password and confirm pasword must be same.");
        }

        setLoading(true);

        const fieldtoSent= {
            name: name,
            email:email,
            phone:phone,
            user_type:user_type
        };

        if(password){
            fieldtoSent.password= password
        };

        try {
            const res= await Apirequests(`users/update-user/${user?._id}`,'PUT',fieldtoSent,{
                Authorization:`Bearer ${token}`
            });

            if (res.success) {
                SuccessTost(res.message || "User updated successfully.");
                close();
                setRefresh((prev) => !prev); // Trigger parent refresh
            } else {
                ErrorTost(res.message || "Something went wrong.");
            }
        } catch (error) {
            console.error("updateUserError:", error);
            ErrorTost("Something went wrong, please try again later.");
        }
        setLoading(false);
    };

    return (
        <div className="flex flex-col justify-center px-4 sm:px-3 lg:px-4">
            <div className="sm:mx-auto sm:w-full sm:max-w-md">
                <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
                    Edit User
                </h2>
            </div>

            <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
                <div className="bg-gray-800 py-8 px-4 shadow sm:rounded-lg sm:px-10">
                    <form className="space-y-6" 
                    onSubmit={handleSubmit}
                    >
                        <div>
                            <label htmlFor="name" className="block text-sm font-medium text-white">
                                Name
                            </label>
                            <div className="mt-1">
                                <input
                                    id="name"
                                    name="name"
                                    type="text"
                                    className={`appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm`}
                                    value={formData.name}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                        <div>
                            <label htmlFor="phone" className="block text-sm font-medium text-white">
                                Phone
                            </label>
                            <div className="mt-1">
                                <input
                                    id="phone"
                                    name="phone"
                                    type="tel"
                                    className={`appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm`}
                                    value={formData.phone}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                        <div>
                            <label htmlFor="email" className="block text-sm font-medium text-white">
                                Email address
                            </label>
                            <div className="mt-1">
                                <input
                                    id="email"
                                    name="email"
                                    type="email"
                                    className={`appearance-none block w-full px-3 py-2 text-gray-400 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm`}
                                    value={formData.email}
                                    onChange={handleChange}
                                    disabled={user?.email}
                                />
                            </div>
                        </div>

                        <div>
                            <label htmlFor="password" className="block text-sm font-medium text-white">
                                Password
                            </label>
                            <div className="mt-1">
                                <input
                                    id="password"
                                    name="password"
                                    type="text"
                                    className={`appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm`}
                                    value={formData.password}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                        <div>
                            <label htmlFor="confirmpassword" className="block text-sm font-medium text-white">
                                Confirm Password
                            </label>
                            <div className="mt-1">
                                <input
                                    id="confirmpassword"
                                    name="confirmPassword"
                                    type="text"
                                    className={`appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm`}
                                    value={formData.confirmPassword}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                        <div>
                            <label htmlFor="user_type" className="block text-sm font-medium text-white">
                                Confirm Password
                            </label>
                            <div className="mt-1">
                            <select
                                name="user_type"
                                value={formData.user_type}
                                onChange={handleChange}
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            >
                                <option value="user">User</option>
                                <option value="admin">Admin</option>
                            </select>
                            </div>
                        </div>

                        <div>
                            <button
                                type="submit"
                                className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                            >
                                {loading ? <BtnSpinner /> : "Update User"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default EditUser;
